import { render } from "./SupportMasqueradeView.vue?vue&type=template&id=63477c49"
import script from "./SupportMasqueradeView.vue?vue&type=script&lang=js"
export * from "./SupportMasqueradeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/SupportViews/SupportMasqueradeView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63477c49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63477c49', __exports__)) {
    api.reload('63477c49', __exports__)
  }
  
  module.hot.accept("./SupportMasqueradeView.vue?vue&type=template&id=63477c49", () => {
    api.rerender('63477c49', render)
  })

}


export default __exports__